// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
    deleteDoc, getFirestore, collection, doc,
    setDoc, getDoc, getDocs, updateDoc
} from "firebase/firestore";
// import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
import { getAnalytics, logEvent, setUserId } from "firebase/analytics";
import {
    getAuth, createUserWithEmailAndPassword,
    signInAnonymously, signInWithEmailAndPassword,
    updateProfile, signOut, sendEmailVerification,
    setPersistence, browserSessionPersistence,
    sendPasswordResetEmail, EmailAuthProvider, updatePassword,
    verifyBeforeUpdateEmail, reauthenticateWithCredential
} from "firebase/auth";
import {
    getStorage, ref, getDownloadURL,
    listAll, uploadBytes, deleteObject
} from 'firebase/storage';
import { getFunctions, httpsCallable } from "firebase/functions";


import { connectFirestoreEmulator } from "firebase/firestore";
import { connectAuthEmulator } from "firebase/auth";
import { connectStorageEmulator } from "firebase/storage";
import { connectFunctionsEmulator } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDSzhBpA2Jro3-E1DM8DFiSMj5nHxyZmmM",
    authDomain: "kci-pricing-calculator.firebaseapp.com",
    databaseURL: "https://kci-pricing-calculator-default-rtdb.firebaseio.com",
    projectId: "kci-pricing-calculator",
    storageBucket: "kci-pricing-calculator.appspot.com",
    messagingSenderId: "199319592870",
    appId: "1:199319592870:web:e93fc8e8d9e1a6f8867967",
    measurementId: "G-8YC6K0B9D6"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const firestore = getFirestore(app);
// const db = getDatabase(app);
const functions = getFunctions(app);
const storage = getStorage(app);

if (window.location.host === 'localhost:3000' || window.location.host === '127.0.0.1:5000') {
    connectAuthEmulator(auth, 'http://localhost:9099');
    // connectDatabaseEmulator(db, '127.0.0.1', 9000);
    connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
    connectStorageEmulator(storage, "127.0.0.1", 9199);
}

const actionCodeSettings = {
    url: `${window.location.origin}/kci/admin/login/user`,
    handleCodeInApp: false
};

export class FirebaseService {

    setUser;
    setNotification;

    constructor(setUserContext, setNotificationContext) {
        this.setUser = setUserContext;
        this.setNotification = setNotificationContext;
    }

    handleError(error) {
        if (/* error.code && */ error.message) {
            this.setNotification({
                open: true,
                // message: `${error.code} - ${error.message}`
                message: `${error.message}`
            });
        } else {
            this.setNotification({
                open: true,
                message: error
            });
        }
    }

    // ======================================================================
    // AUTHENTICATION SECTION
    // ======================================================================

    /**
     * Creates a user from an email and password
     * @param {{
     *  email: string,
     *  password: string,
     *  name: string | null,
     *  url: string | null
     * }} info Object containing the user's email and password properties
     */
    createUser(info) {
        return createUserWithEmailAndPassword(auth, info.email, info.password).then(res => {
            // this.setUser(res.user);
            if (info?.name?.length || info?.url?.length) {
                return this.updateUserInfo(info.name, info.url).then(() => {
                    logEvent(analytics, 'sign_up', { method: 'Email and password' });
                    return this.verifyEmail();
                });
            } else {
                return this.verifyEmail();
            }
        }).catch(err => {
            this.handleError(err);
            return false;
        });
    }

    /**
     * Used to verify the signed in user's email.
     * @returns A boolean promise
     */
    verifyEmail() {
        return sendEmailVerification(auth.currentUser, actionCodeSettings).then(() => {
            this.handleError('A verification email has been sent. Please click the link in the email and sign in again.');
            return true;
        }).catch(err => {
            this.handleError(err);
            return false;
        });
    }

    /**
     * Used to send a password reset email to the signed in user.
     * @param {string} email The user's email to send the password reset email.
     * @returns A boolean promise
     */
    resetPassword(email) {
        return sendPasswordResetEmail(auth, email).then(() => {
            this.handleError('A password reset email has been sent');
            return true;
        }).catch(err => {
            this.handleError(err);
            return false;
        });
    }

    /**
     * Updates either a user's name / photo.
     * @param {string | null | undefined} name User name to update.
     * @param {string | null | undefined} url The url for the user's photo.
     */
    updateUserInfo(name, url) {
        if (auth.currentUser != null && !auth.currentUser?.isAnonymous) {
            let body = {
                displayName: name,
                // photoURL: url
            }
            return updateProfile(auth.currentUser, body).then(() => {
                this.handleError('Profile updated successfully');
                this.setUser(auth.currentUser);
                return true;
            }).catch(err => {
                this.handleError(err);
                return false;
            });
        } else {
            this.handleError('NOT SIGNED IN');
            return Promise.reject(false);
        }
    }

    /**
     * Updates the user password.
     * @param {string} currPassword Current User password to reauthenticate.
     * @param {string} newPassword User password to update.
     */
    changePassword(currPassword, newPassword) {
        if (auth.currentUser != null && !auth.currentUser?.isAnonymous) {
            const credential = EmailAuthProvider.credential(
                auth.currentUser.email,
                currPassword
            );
            return reauthenticateWithCredential(auth.currentUser, credential).then(res => {
                return updatePassword(res.user, newPassword).then(() => {
                    this.handleError('Password updated successfully');
                    return true;
                }).catch(err => {
                    this.handleError(err);
                    return false;
                });
            }).catch(err => {
                this.handleError(err);
                return false;
            });
        } else {
            this.handleError('NOT SIGNED IN');
            return Promise.reject(false);
        }
    }

    /**
     * Updates the user email.
     * @param {string} newEmail The user's new email.
     * @param {string} password The user's current password.
     */
    changeEmail(newEmail, password) {
        if (auth.currentUser != null && !auth.currentUser?.isAnonymous) {
            const credential = EmailAuthProvider.credential(
                auth.currentUser.email,
                password
            );
            return reauthenticateWithCredential(auth.currentUser, credential).then(res => {
                return verifyBeforeUpdateEmail(res.user, newEmail, actionCodeSettings).then(() => {
                    this.handleError('Email verification sent to the new email');
                    return true;
                }).catch(err => {
                    this.handleError(err);
                    return false;
                });
            });
        } else {
            this.handleError('NOT SIGNED IN');
            return Promise.reject(false);
        }
    }

    /**
     * Called to sign in a guest user or sign in with
     * an email and password and assigns the user object the result.
     * @param {{email: string, password: string}} info The request object with properties email and password for signing in.
     */
    login(info) {
        for (let key of Object.keys(window.sessionStorage)) {
            let item = JSON.parse(window.sessionStorage[key]);
            if (item?.uid && item?.email) {
                this.setUser(item);
                return Promise.resolve(item);
            }
        }
        return setPersistence(auth, browserSessionPersistence).then(() => {
            if (info) {
                return signInWithEmailAndPassword(auth, info.email, info.password).then(res => {
                    logEvent(analytics, 'login', { method: 'Email and password' });
                    setUserId(analytics, auth.currentUser.uid);
                    this.setUser(res.user);
                    return res.user;
                }).catch(err => {
                    this.handleError(err);
                    return null;
                });
            } else {
                return signInAnonymously(auth).then(res => {
                    logEvent(analytics, 'login');
                    setUserId(analytics, auth.currentUser.uid);
                    this.setUser(res.user);
                    return res.user;
                }).catch(err => {
                    this.handleError(err);
                    return null;
                });
            }
        }).catch(err => {
            this.handleError(err);
            return null;
        });
    }

    /**
     * Logs the user out of the application and signs in as guest.
     */
    logout() {
        return signOut(auth).then(() => {
            return this.login().then(res => {
                this.handleError('You have been signed out');
                return true;
            }).catch(err => {
                this.handleError(`There was a problem signing out:\n ${err.code} - ${err.message}`);
                return false;
            });
        }).catch(err => {
            this.handleError(err);
            return false;
        });
    }

    // ======================================================================
    // FIRESTORE SECTION
    // ======================================================================

    /**
     * Adds/Updates a single document to a collection.
     * @param {string} collectionName The collection name to add the document.
     * @param {string} name The document name.
     * @param {string} data The document object.
     */
    addDocument(collectionName, name, data) {
        if (collectionName && name && data) {
            let path = `${collectionName}/${name}`;
            return setDoc(doc(firestore, path), data).then(() => {
                this.handleError(`Document "${name}" has been added`);
                return true;
            }).catch(err => {
                this.handleError(err);
                return false;
            });
        } else {
            this.handleError('Invalid request arguments');
            return Promise.reject(false);
        }
    }

    /**
     * Updates the document with the new values from the data object.
     * @param {string} collectionName The name of the collection
     * @param {string} docName The name of the document to retrieve
     * @param {*} data Document data to update.
     * @returns Boolean promise.
     */
    updateDocument(collectionName, docName, data) {
        let docRef = doc(firestore, collectionName, docName);
        return updateDoc(docRef, data).then(() => {
            // this.handleError(`Document "${docName}" has been updated`);
            this.handleError(`Document has been updated successfully`);
            return true;
        }).catch(err => {
            this.handleError(err);
            return false;
        });
    }

    /**
     * Retrieves a single document from a collection.
     * @param {string} collectionName The name of the collection
     * @param {string} docName The name of the document to retrieve
     * @returns The document if found, otherwise null
     */
    getDocument(collectionName, docName) {
        let docRef = doc(firestore, collectionName, docName);
        return getDoc(docRef).then(doc => {
            if (doc.exists()) {
                return doc.data();
            } else {
                this.handleError('No such document exists');
                return;
            }
        }).catch(err => {
            this.handleError(err);
            return;
        });
    }

    /**
     * Retrieves all documents within a collection.
     * @param {*} collectionName The name of the collection to retrieve from
     * @returns The document list; can be empty.
     */
    getCollectionDocs(collectionName) {
        return getDocs(collection(firestore, collectionName)).then(data => {
            let result = {}
            if (!data.empty) {
                // data.docs.forEach(item => {
                //     if (collectionName === 'Items') {
                //         let key = item.get('id').split('-')[0];
                //         result[key] ? result[key].push(item.data()) : result[key] = [item.data()];
                //     } else {
                //         result[item.get('id')] = item.data();
                //     }
                // });
                data.forEach(item => {
                    if (collectionName === 'Items') {
                        let key = item.id.split('-')[0];
                        result[key] ? result[key].push(item.data()) : result[key] = [item.data()];
                    } else {
                        result[item.id] = item.data();
                    }
                });
            }
            return result;
        }).catch(err => {
            this.handleError(err);
            return;
        });
    }

    /**
     * Deletes a document from the firestore collection
     * @param {string} collectionName The name of the collection to retrieve from
     * @param {string} docName The name of the document to retrieve
     * @returns 
     */
    deleteDocument(collectionName, docName) {
        let docRef = doc(firestore, collectionName, docName);
        return deleteDoc(docRef).then(() => {
            // this.handleError(`Document "${docName}" was deleted`);
            this.handleError(`Document was deleted successfully`);
        }).catch(err => {
            this.handleError(err);
        });
    }

    // ======================================================================
    // CLOUD STORAGE SECTION
    // ======================================================================

    /**
     * Retrieves all files in cloud storage.
     * @returns An object map containing file names as keys and their url's as values
     */
    getAllStoredImages(path) {
        return listAll(ref(storage, path)).then(async result => {
            let imageMap = {}
            for(let item of result.items) {
                // imageMap[item.name] = item.toString();
                await this.getImage(item.toString()).then(url => imageMap[item.name] = url);
            }
            return imageMap;
        }).catch(err => {
            this.handleError(err);
            return null;
        });
    }

    /**
     * Retrieves a file from storage.
     * @param {string} path The bucket path including the name to the file location.
     * @returns The cloud storage url location.
     */
    getImage(path) {
        return getDownloadURL(ref(storage, path)).then(url => {
            return url;
        }).catch(err => {
            this.handleError(err);
            return null;
        });
    }

    /**
     * Adds or updates a file in storage.
     * @param {Blob | Uint8Array | ArrayBuffer} file Data uploaded as a file.
     * @param {string} path The bucket path including the name to the file location without file type.
     * @returns 
     */
    addImage(file, path) {
        return uploadBytes(ref(storage, path), file).then(result => {
            this.handleError(`Image "${result.ref.name}" uploaded successfully`);
        }).catch(err => {
            this.handleError(err);
        });
    }

    /**
     * Removes a file from cloud storage.
     * @param {string} path Location of file to delete including file name without file type.
     * @returns 
     */
    deleteImage(path) {
        return deleteObject(ref(storage, path)).then(() => {
            this.handleError("File deleted successfully");
        }).catch(err => {
            this.handleError(err);
        });
    }

    // ======================================================================
    // CLOUD FUNCTIONS SECTION
    // ======================================================================

    /**
     * NEEDS TESTING - Should send an email containg the quoted jobs.
     * @returns 
     */
    sendQuote(doc, name) {
        let body = {
            pdf: doc,
            name: name
        }
        const request = httpsCallable(functions, 'sendQuote');
        return request(body).then(data => {
            // this.handleError('Quote sent successfully');
        }).catch(err => {
            this.handleError(err);
        });
    }
}
